export const STAT_LABELS = [
  'Lift',
  'Zone',
  'Difficulty',
  'Features',
  'Length',
  'Start',
  'End'
]
